import {  ADD_FACULTY_CITIZENSHIP, ADD_FACULTY_CITIZENSHIP_ERROR, ADD_FACULTY_CITIZENSHIP_SUCCESS, DELETE_CITIZENSHIP_ERROR, DELETE_CITIZENSHIP_SUCCESS, DELETE_FACULTY_CITIZENSHIP, GET_CITIZENSHIP_LIST, GET_CITIZENSHIP_LIST_ERROR, GET_CITIZENSHIP_LIST_SUCCESS, GET_CITIZENSHIP_SELECT_ITEMS_SUCCESS, RESET_FORMIK_INITIAL_VALUES, SET_FORMIK_INITIAL_VALUES, UPDATE_FACULTY_CITIZENSHIP, UPDATE_FACULTY_CITIZENSHIP_ERROR, UPDATE_FACULTY_CITIZENSHIP_SUCCESS } from "./type";

const initialState = {
    selectItems: {},
    citizenshipList: [],
    formikInitialValues: {
        country: 0,
        effectiveDate: null,
        alternateIDType: 0,
        alternateID: "",
        taxSSNID: ""
    },
    isLoading: false
};

const facultyCitizenshipReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case GET_CITIZENSHIP_LIST_SUCCESS:
            return { ...state, citizenshipList: payload, isLoading: false };
        case GET_CITIZENSHIP_SELECT_ITEMS_SUCCESS:
            return { ...state, selectItems: payload, isLoading: false };
        case ADD_FACULTY_CITIZENSHIP_SUCCESS:
        case UPDATE_FACULTY_CITIZENSHIP_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };
        case DELETE_CITIZENSHIP_SUCCESS:
            const newList = state.citizenshipList.filter(item => item.citizenshipID !== payload);
            return {
                ...state,
                isLoading: false,
                citizenshipList: newList
            }
        case SET_FORMIK_INITIAL_VALUES:
            return { ...state, formikInitialValues: payload };
        case RESET_FORMIK_INITIAL_VALUES:
            return {
                ...state, formikInitialValues: {
                    country: 0,
                    effectiveDate: null,
                    alternateIDType: 0,
                    alternateID: "",
                    taxSSNID: ""
                }
            };
        case GET_CITIZENSHIP_LIST_ERROR:
        case ADD_FACULTY_CITIZENSHIP_ERROR:
        case UPDATE_FACULTY_CITIZENSHIP_ERROR:
        case DELETE_CITIZENSHIP_ERROR:
            return { ...state, isLoading: false };
        case GET_CITIZENSHIP_LIST:
        case ADD_FACULTY_CITIZENSHIP:
        case UPDATE_FACULTY_CITIZENSHIP:
        case DELETE_FACULTY_CITIZENSHIP:
            return { ...state, isLoading: true };
        default:
            return state;
    }
};

export default facultyCitizenshipReducer;